// extracted by mini-css-extract-plugin
module.exports = {"sticky":"styles_sticky__naou2","gradient":"styles_gradient__tUexJ","wheel":"styles_wheel__1ZtIM","rotating":"styles_rotating__jaRjF","wheelWrap":"styles_wheelWrap__kcfwW"};